import { Link } from 'react-router-dom';
import styled from 'styled-components/macro';

import { THEME_COLOR, BREAKPOINT } from '../../constant';
import { rotateY } from '../../animation/keyframe';

interface ActiveProps {
  active?: boolean;
}

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  height: 6rem;

  padding: 0rem 2rem;
  @media only screen and (min-width: ${BREAKPOINT}px) {
    height: 10rem;
    padding: 0rem 5rem;
  }
`;

export const Logo = styled.img`
  display: none;
  @media only screen and (min-width: ${BREAKPOINT}px) {
    display: block;
    width: 15rem;
  }
`;

export const MobileLogo = styled.img`
  width: 9rem;
  @media only screen and (min-width: ${BREAKPOINT}px) {
    display: none;
  }
`;

export const DesktopButtons = styled.div`
  height: 100%;
  display: none;
  @media only screen and (min-width: ${BREAKPOINT}px) {
    display: flex;
  }
`;

export const MobileButtons = styled.div`
  height: 100%;
  display: flex;
  background-color: #ffffff;
  align-items: center;

  @media only screen and (min-width: ${BREAKPOINT}px) {
    display: none;
  }
`;

export const Button = styled.button`
  height: 100%;
  outline: none;

  border: none;
  background-color: inherit;
  font-size: 1.7rem;
  font-weight: 800;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 1rem;

  &:hover {
    background-color: ${THEME_COLOR.GRAY};
  }

  .icon {
    width: 3rem;
    height: 3rem;
    margin-right: 2px;
  }

  img {
    width: 5rem;
    height: 5rem;
    object-fit: contain;
  }

  small {
    font-weight: 700;
  }

  @media only screen and (min-width: ${BREAKPOINT}px) {
    transition: background-color 0.5s;
  }
`;

export const DesktopLink = styled(Link)`
  text-decoration: none;
  color: inherit;

  display: none;
  @media only screen and (min-width: ${BREAKPOINT}px) {
    display: block;
  }
`;

export const DesktopATag = styled.a`
  text-decoration: none;
  color: inherit;

  display: none;
  @media only screen and (min-width: ${BREAKPOINT}px) {
    display: block;
  }
`;

export const MobileAtag = styled.a`
  text-decoration: none;
  color: inherit;

  display: block;
  @media only screen and (min-width: ${BREAKPOINT}px) {
    display: none;
  }

  img {
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;
    border: 2px solid black;
  }
`;

export const MobileLink = styled(Link)`
  text-decoration: none;
  color: inherit;

  display: flex;
  justify-content: center;
  align-items: center;
  @media only screen and (min-width: ${BREAKPOINT}px) {
    display: none;
  }
`;

export const ProfileImage = styled.img`
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
`;

export const ProfileLink = styled.div`
  text-decoration: none;
  color: inherit;

  display: none;
  @media only screen and (min-width: ${BREAKPOINT}px) {
    display: block;
    width: 15rem;
  }
`;

export const MobileProfileLink = styled.div`
  text-decoration: none;
  color: inherit;
  width: 8.5rem;

  display: block;
  height: 100%;

  @media only screen and (min-width: ${BREAKPOINT}px) {
    display: none;
  }
`;

export const ProfileButton = styled.button<MenuProps>`
  background-color: ${(props) => (props.show ? `${THEME_COLOR.GRAY}` : 'white')};

  height: 100%;
  outline: none;

  border: none;
  font-size: 1.7rem;
  font-weight: bolder;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: ${THEME_COLOR.GRAY};
  }

  .icon {
    width: 2rem;
    height: 2rem;
  }

  @media only screen and (min-width: ${BREAKPOINT}px) {
    height: 10rem;
    width: 8.7rem;
    padding: 0rem 2rem;
    transition: background-color 0.5s;
  }
`;

export const MobileProfileButton = styled.button<MenuProps>`
  background-color: ${(props) => (props.show ? `${THEME_COLOR.GRAY}` : 'white')};
  /* background-color: white; */

  height: 100%;
  margin-left: auto;
  outline: none;

  border: none;
  font-size: 1.3rem;
  font-weight: bolder;

  display: flex;
  align-items: center;
  justify-content: flex-end;

  .icon {
    width: 2rem;
    height: 2rem;
  }

  @media only screen and (min-width: ${BREAKPOINT}px) {
    display: none;
  }
`;

export const Menu = styled.div`
  display: flex;
  font-size: 1.7rem;
`;

export const MobileMenu = styled.div`
  display: flex;
  font-size: 1.3rem;

  @media only screen and (min-width: ${BREAKPOINT}px) {
    display: none;
  }
`;

interface MenuProps {
  show?: boolean;
}

export const MenuOptions = styled.div<MenuProps>`
  display: ${(props) => (props.show ? 'flex' : 'none')};

  flex-direction: column;
  border: 1px solid ${THEME_COLOR.GRAYER};

  background-color: white;

  z-index: 1000;

  width: 30rem;
  justify-content: flex-end;
  overflow: auto;

  animation: ${rotateY} 0.3s ease-in-out;
  transform-origin: top center;
`;

export const MobileMenuOptions = styled.div<MenuProps>`
  display: ${(props) => (props.show ? 'flex' : 'none')};

  flex-direction: column;
  border: 1px solid ${THEME_COLOR.GRAYER};

  z-index: 1000;

  width: 8.5rem;
  overflow: auto;

  animation: ${rotateY} 0.3s ease-in-out;
  transform-origin: top center;

  @media only screen and (min-width: ${BREAKPOINT}px) {
    display: none;
  }
`;

export const MenuOption = styled(Link)`
  text-decoration: none;
  color: inherit;
  border: 1px solid ${THEME_COLOR.GRAYER};

  display: block;

  padding: 1.6rem 1.6rem;

  &:hover {
    background-color: ${THEME_COLOR.GRAYER};
  }
`;

export const MobileMenuOption = styled(Link)`
  text-decoration: none;
  color: inherit;
  border: 1px solid ${THEME_COLOR.GRAYER};
  background-color: white;

  display: block;

  padding: 1rem 1rem;

  text-align: right;
`;
